import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type StaticData = {};

export class Static extends Resource<StaticData> {
  constructor(axiosInstance: AxiosInstance) {
    super("static", axiosInstance);
  }

  public async listScreeningLists(): Promise<string[]> {
    const path = `screeningLists`;
    return this.request({ method: Method.GET, path });
  }

  public async listSupportedDocuments(): Promise<string[]> {
    const path = `supportedDocuments`;
    return this.request({ method: Method.GET, path });
  }
}
